import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import ListItemAvatar from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/ListItemAvatar';
import Badge from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Badge';
import fr from 'facet-rest';
import { Avatar } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4';
import { getBorder } from 'Components/utils';
import { DataValueMap } from 'Helpers/Testing';

const useStyles = buildUseStyles('ThreadListItemAvatar', (theme) => ({
  root: {
  },
  threadMemberCountBadge: {
    fontSize: theme.typography.body2.fontSize,
    color: theme.palette.common.black,
    ...getBorder(theme, { all: true, color: theme.palette.common.white }),
    height: 20,
    width: 20,
  },
  avatar: {
    borderRadius: theme.radius.full,
    height: theme.spacing(7),
    width: theme.spacing(7),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

const ThreadListItemAvatar = ({
  threadResource,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const numberOfThreadMembers = threadResource.attr('threadMembers')?.resources()?.list().length;

  return (
    <ListItemAvatar className={classNames(classes.avatar)}>
      <Badge
        classes={{
          badge: classes.threadMemberCountBadge,
        }}
        overlap={'circle'}
        variant={'standard'}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        color={'actionSelected'}
        badgeContent={numberOfThreadMembers || '0'}
        {...DataValueMap
          .init('messages-page-thread-list-item-member-count')
          .append(DataValueMap.keyMap.dataResourceId, threadResource.id())
          .build()}
      >
        <Avatar
          src={threadResource?.relationship(fr.relationships.avatar.name)
            ?.link('related')
            ?.url()}
          alt={`${threadResource?.attr('avatarParticipantName')}`}
          {...DataValueMap
            .init('messages-page-thread-list-item-avatar')
            .append(DataValueMap.keyMap.dataResourceId, threadResource.id())
            .build()}
        />
      </Badge>
    </ListItemAvatar>
  );
};

ThreadListItemAvatar.defaultProps = {
};

ThreadListItemAvatar.propTypes = {
  threadResource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export { ThreadListItemAvatar };
